<script setup lang="ts">
defineProps<{
  name: string
  title?: string
}>()
</script>

<template>
  <i :class="`icon icon-${name}`">
    <svg :aria-label="title">
      <title v-if="title">{{ title }}</title>
      <use :href="`#${name}`" />
    </svg>
  </i>
</template>
